module.exports = __webpack_public_path__ + "static/adelabu-a87de512447103fc66b9b04cf238d58d.jpg";